<template>
  <v-card width="300">
    <v-card-title>
      Configuración
    </v-card-title>

    <v-tabs background-color="transparent" grow v-model="tab">
      <v-tab href="#tab-0">
        General
      </v-tab>
      <v-tab href="#tab-1">
        Diseño
      </v-tab>
      <v-tab href="#tab-2">
        SAP
      </v-tab>
      <v-tab href="#tab-3">
        Token
      </v-tab>
      <v-tab href="#tab-4">
        Firma
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item :value="'tab-0'">
        <v-card class="text-center">
          <v-list v-if="user?.NtpID > 0" class="mx-auto">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="headline">
                  {{ user.NtpName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ user.NtpPaternalSurname }}
                  {{ user.NtpMaternalSurname }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-img v-if="personImage != null" contain :src="personImage" height="200"></v-img>
            <v-list-item v-if="user.CtrContract != null">
              <v-list-item-content>
                <v-list-item-title class="headline">
                  {{ user.CtrContract == null ? "" : user.CtrContract.PstName }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ user.CtrContract == null ? "" : user.CtrContract.AreName }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-card-actions>
            <v-btn small color="primary" block @click="logout">
              Cerrar sesión
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="'tab-1'">
        <v-card max-height="400" style="overflow-x:hidden">
          <v-card-text>
            Tema
            <v-switch v-model="Statusbackground" label="Modo Oscuro" @change="status(Statusbackground)"></v-switch>

            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>Toolbar</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-color-picker :mode.sync="mode" v-model="generatetext" dot-size="10" @input="inputTool"></v-color-picker>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header> Navigation</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-color-picker :mode.sync="mode" v-model="navtext" dot-size="10" @input="inputNavigation"></v-color-picker>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-switch v-model="IsReset" label="Configuracion Defecto" @change="Reset(IsReset)"></v-switch>
          </v-card-text>
          <v-card-actions>
            <v-btn block small color="primary" @click="insert">
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="'tab-2'">
        <s-manager-sap :activate="managerSAP" v-model="userSAP" />
      </v-tab-item>
      <v-tab-item :value="'tab-3'">
        <v-card>
          <v-card-text>
            <v-text-field
              v-model="token"
              label="Token de acceso"
              outlined
              dense
              readonly
              append-outer-icon="mdi-content-copy"
              @click:append-outer="copyToken"
            />

            <!-- <v-text-field
              v-model="getUserId"
              label="ID de Usuario"
              outlined
              dense
              readonly
              append-icon="mdi-account"
            /> -->

            <v-btn
              color="primary"
              block
              small
              class="mb-4"
              @click="generateToken"
            >
              Generar nuevo token
            </v-btn>

            <v-row>
              <v-col cols="12" class="s-col-form">
                <s-text
                  v-model="tokenCreatedAt"
                  label="Fecha de creación"
                  outlined
                  dense
                  readonly
                  prependInnerIcon="mdi-calendar-start"
                />
              </v-col>

              <v-col cols="12">
                <s-text
                  v-model="tokenExpiresAt"
                  label="Fecha de vencimiento"
                  outlined
                  dense
                  readonly
                  prependInnerIcon="mdi-calendar-end"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :value="'tab-4'">
        <v-card>
          <v-card-text>
            <div class="text-subtitle-1 mb-2">Firma digital</div>
            <v-file-input
              v-model="signatureFile"
              accept="image/*"
              label="Cargar firma (imagen)"
              prepend-icon="mdi-draw"
              outlined
              dense
              @change="onSignatureChange"
              clearable
            ></v-file-input>
            
            <div v-if="signaturePreview" class="d-flex justify-center my-4" style="border: 1px dashed #ccc; padding: 10px; border-radius: 4px;">
              <v-img :src="signaturePreview" max-height="150" contain></v-img>
            </div>
            
            <v-btn
              color="primary"
              block
              small
              class="mb-4"
              :disabled="!signatureFile"
              @click="saveSignature"
            >
              Guardar Firma
            </v-btn>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>
<script>
import _sQryConfigurationService from "@/services/QueryManager/QryConfigurationService.js";
import sManagerSap from "@/views/Security/UserSAP/ManagerAccount.vue";
import _sUserConfig from "@/services/Security/UserConfigurationService.js";
import _sHelper from "@/services/HelperService";
import _sUserService from "@/services/Security/UserService.js";
import { get } from "jquery";
export default {
  components: { sManagerSap },
  props: {
    activate: {
      type: Boolean,
      default: false,
    },
    configUser: {
      type: Object,
      default: null,
    },
    user: {
      type: Object,
      default: { PrsDocumentNumber: "" },
    },
    personImage: null,
  },
  data: () => ({
    IsReset: false,
    method: "",
    tab: null,
    managerSAP: false,
    userSAP: {},
    Statusbackground: false,
    IsInitialize: false,
    Navigation: "",
    Tool: "",
    generatetext: "",
    navtext: "",
    loading: false,
    mode: "hexa",
    panel: [],
    config: [{}],
    stylemodedark: "rgb(53, 54, 58)",
    token: "",
    tokenCreatedAt: "",
    tokenExpiresAt: "",
    signatureFile: null,
    signaturePreview: null,
  }),
  mounted() {
    this.method = "show";
  },
  methods: {
    initialize() {
      this.generatetext = "#e0e0e0";
      this.navtext = "#E0E0E0";
      this.Statusbackground = this.configUser == null ? false : this.configUser.CfgTheme === 1 ? true : false;
      this.getUserId = this.$fun.getUserID();
      
      let savedSignature = this.user && this.user.SignatureBase64 ? this.user.SignatureBase64 : this.$fun.getSignatureBase64();
      if (savedSignature && savedSignature !== "null" && savedSignature !== "undefined" && savedSignature !== "") {
        this.signaturePreview = "data:image/png;base64," + savedSignature;
      }
      
      this.listToken();
    },
    generateToken() {
      _sQryConfigurationService.createdToken(this.$fun.getUserID()).then((r) => {
        let data = r.data;
        this.token = data.PtkToken;
        this.tokenCreatedAt = this.$fun.formatDateView(data.PktDateBegin);
        this.tokenExpiresAt = this.$fun.formatDateView(data.PktDateEnd);
        this.$fun.alert("Token generado correctamente", "success");
      })
    },

    listToken(){
      _sQryConfigurationService.paginationToken(this.$fun.getUserID()).then((r) => {
        let data = r.data;
        this.token = data.PtkToken;
        this.tokenCreatedAt = this.$fun.formatDateView(data.PktDateBegin);
        this.tokenExpiresAt = this.$fun.formatDateView(data.PktDateEnd);
      })
    },
    copyToken() {
      if (!this.token) {
        this.$fun.alert("No hay token para copiar 😅", "warning");
        return;
      }

      navigator.clipboard.writeText(this.token)
        .then(() => {
          this.$fun.alert("Token copiado al portapapeles 📋", "success");
        })
        .catch(() => {
          this.$fun.alert("No se pudo copiar el token 😢", "error");
        });
    },
    status(value) {
      this.IsReset = false;
      if (value) {
        this.Statusbackground = value;
        this.Tool = this.stylemodedark;
        this.Navigation = this.stylemodedark;
      } else {
        this.Statusbackground = false;
        this.Tool = "";
        this.Navigation = "";
        this.$emit("getReset", true);
      }
      this.$emit("getBackground", value);
    },
    Reset(value) {
      this.Statusbackground = false;
      this.Tool = "";
      this.Navigation = "";
      this.$emit("getReset", value);
    },
    inputNavigation(value) {
      this.loading = true;
      if (this.loading) {
        this.IsReset = false;
        this.$emit("getNavigation", value);
        this.Navigation = value;
      } else this.Navigation = this.navtext;
    },
    inputTool(value) {
      this.loading = true;
      if (this.loading) {
        this.$emit("getToolbar", value);
        this.Tool = value;
      }
    },
    insert() {
      let conf = {
        CfgID: this.configUser == null ? 0 : this.configUser.CfgID,
        CfgDescription: "Configuration",
        CfgTheme: this.Statusbackground ? 1 : 0,
        CfgToolbar: this.Tool,
        CfgNavigation: this.Navigation == "" ? this.navtext : this.Navigation,
        UsrID: this.$fun.getUserID(),
        SecStatus: 1,
        UsrCreateID: this.$fun.getUserID(),
      };
      _sUserConfig.save(conf, this.$fun.getUserID()).then((response) => {
        this.$fun.alert("Registros actualizados correctamente", "success");
      });
    },
    logout() {
      this.$emit("getLogout");
    },
    onSignatureChange(file) {
      if (file) {
        const tempUrl = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");
          
          // Tamaño máximo para la firma (reasignando proporciones)
          const maxWidth = 500;
          const maxHeight = 250;
          let width = img.width;
          let height = img.height;
          
          if (width > maxWidth || height > maxHeight) {
            const ratio = Math.min(maxWidth / width, maxHeight / height);
            width = width * ratio;
            height = height * ratio;
          }
          
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          
          this.signaturePreview = canvas.toDataURL("image/png");
          URL.revokeObjectURL(tempUrl);
        };
        img.src = tempUrl;
      } else {
        this.signaturePreview = null;
      }
    },
    saveSignature() {
      if (!this.signaturePreview) return;

      // Extraer el string Base64 ya reescalado desde la previsualización
      const base64String = this.signaturePreview.split(',')[1];
      
      let data = {
        UsrID: this.$fun.getUserID(),
        SignatureBase64: base64String
      };

      _sUserService.saveSignature(data, this.$fun.getUserID())
        .then(() => {
          localStorage.setItem("SignatureBase64", base64String);
          this.$fun.alert("Firma guardada correctamente", "success");
        })
        .catch((error) => {
          console.error(error);
          this.$fun.alert("Error al guardar la firma", "error");
        });
    },
  },
  computed: {
    show() {
      return this.method == "show";
    },
  },
  watch: {
    activate() {
      this.method = "show";
      this.Statusbackground = this.configUser == null ? false : this.configUser.CfgTheme === 1 ? true : false;
    },
    user: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  created() {
    this.initialize();
  },
};
</script>
